module.exports = __webpack_public_path__ + "static/media/RadioModulation.440985a4.jpg";